const CalendarIcon = ({ className = "" }) => (
  <svg aria-hidden="true" className={className} fill="none" viewBox="0 0 24 24">
    <path
      d="M7 3.75V6M17 3.75V6M4.5 9H19.5M6.75 5.25H17.25C18.4926 5.25 19.5 6.25736 19.5 7.5V18.75C19.5 19.9926 18.4926 21 17.25 21H6.75C5.50736 21 4.5 19.9926 4.5 18.75V7.5C4.5 6.25736 5.50736 5.25 6.75 5.25Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.8"
    />
  </svg>
);

export default CalendarIcon;
